import styled from "styled-components/macro";
import { NAV_HEIGHT_PX } from "../../constants/constants";

export const TrendsPageStyles = styled.div`
  @media print {
    background-color: unset;
  }
  min-height: calc(100vh - ${NAV_HEIGHT_PX}px);
  padding-bottom: 6em;

  .MuiCollapse-wrapperInner {
    margin-top: -12px;
  }
  .PnlChart .MuiCollapse-wrapperInner {
    margin-top: 0px;
  }
  .centerMetric {
    background: none;
  }
  .trendChartWrapper {
    margin-top: 1em;
  }
`;
